// Single source of truth for the response_payload sent with
// completeChecklistItem(...) after an ActionPanel completes. Used by the
// lead-detail orchestrator (AttendedGuidedChecklistV2) and NextTaskCardDialog.
//
// - LEAD_NEXT_ACTION: the BE requires resolved_action; NextActionPanel attaches
//   `resolvedAction` to the item before calling onComplete.
// - FollowUpPanel (guided multi-channel follow-up) attaches `channelOutcomes`
//   ([{channel,state}…]) — persisted as response_payload.channels.
export function buildCompletionPayload(completedItem) {
    let payload = completedItem?.resolvedAction
        ? { resolved_action: completedItem.resolvedAction }
        : null;
    if (Array.isArray(completedItem?.channelOutcomes) && completedItem.channelOutcomes.length > 0) {
        payload = { ...(payload || {}), channels: completedItem.channelOutcomes };
    }
    return payload;
}

export default buildCompletionPayload;
